export default "__VITE_ASSET__DzJ7JMGk__"